// <핫이슈 박스 컴포넌트>

// 2021.11.01 기획서 기준  광고까지 총 5개 박스
// 5. LIVE 타입
// CCI 핫이슈 관리자에서 선택된 채널
// ① 관리자에서 수동 입력된 이미지
//     - 가로는 고정, 높이는 이미지 비율에 따라 가변
// ② LIVE 시작 전 : 관리자에서 수동 입력된 이미지와 그 위에 “LIVE 준비 중입니다.” 이미지 레이어
// ② LIVE 시작 후 : 채널의 실시간 LIVE 썸네일 + 왼쪽 상단에 라이브 버튼 노출

import Image from 'next/image';
import Link from 'next/link';
import React, { useState } from 'react';
import { toContentDate } from '../../../../../src/common/utils/dateUtil';
import { getClickLinkParams } from '../../../../common/utils/appLinkUtil';
import ShareBox from './ShareBox';

// "type": 5,
// "title": "Type5_live채널_수동순서_SBS",
// "top_img_url": "https://img2.sbs.co.kr/img/sbs_cms/WE/2021/11/30/rDi1638253489281.png",
// "content_img_url": "https://img2.sbs.co.kr/img/sbs_cms/WE/2021/09/07/pQn1630977630453-640-360.jpg",
// "live_img_url": "https://program-image.cloud.sbs.co.kr/sbs.jpg",
// "link_url": "https://www.sbs.co.kr/live/S01",
// "content_date": "20211201165208",
// "broad_date": "2021-11-30T15:40:00.000Z",
// "sort": 5

// TODO 라이브일시 라이브 버튼  live_img_url 가 있을때 이걸로 뿌리면서 나오게
export default function Box(props) {
  const [width, setWidth] = useState(384);
  const title = props.title; // 타이틀
  const contentDate = props.content_date; // 게시날짜(데이터 케스팅 유무 확인필요)
  const linkUrl = props.link_url; // 링크 url

  const topImgUrl = props.top_img_url;
  const contentImgUrl = props.content_img_url; // 이미지 주소 urlList
  const contentDateCast = contentDate ? toContentDate(contentDate) : '';

  const liveImgUrl = props.live_img_url;
  // const liveImgUrl = null;

  // try {
  //   const test = topImgUrl.substr(0, 4);
  //   const test1 = bottomImgUrl.substr(0, 4);
  //   if (test !== 'http') {
  //     return (
  //       <>
  //       </>
  //     );
  //   }
  // } catch (error) {
  //   console.error(error);
  //   return (
  //     <>
  //     </>
  //   );
  // }

  // media_url

  return (
    <>

      {/* 라이브 영상 재생중일때 current 클래스 추가해주세요. */}
      <div className={(liveImgUrl != null ? ' hotmodule_box_w_type5 current' : 'hotmodule_box_w_type5')}>
        <Link href={getClickLinkParams(linkUrl, 'div=hotissue')} >
          <a target={"_blank"} rel={"noopener noreferrer"} className='hmb_link'>
            <div className='hmb_image_w'>
              <div className='hmb_image_inner'>
                {/* 그리는 영역 문제있어서 일단 next js 걷어냄  */}
                <img
                  style={{ width: width, height: 'auto' }}
                  src={topImgUrl}
                  alt={title}
                />
              </div>
            </div>
            <div className='hmb_live_w'>
              <div className='round_label_red'><span className='round_ltc_text'>라이브</span></div>
              <p className='mbl_notice_text'><strong className='mbl_notice_bold'>라이브 </strong>준비중입니다.</p>
              {/* 라이브 썸네일이미지 또는 비디오 제공 */}
              <div className='hmb_live_viewer_w'>
                {/* 그리는 영역 문제있어서 일단 next js 걷어냄  */}
                {
                  liveImgUrl != null &&
                  (
                    <Image
                      src={liveImgUrl}
                      alt={title}
                      className='hmb_image'
                      layout='fill'
                      quality={props.imageQuality || 50}
                    />
                  )
                }
                {
                  liveImgUrl == null &&
                  (
                    <img
                      src={contentImgUrl}
                      alt={title}
                      className='hmb_image'
                    />
                  )
                }
              </div>
            </div>
            <div className='hmb_info_w'>
              {contentDate != null && contentDateCast !== null && contentDateCast !== '' && (
                <div className='hmbif_update_time_w'>
                  <span className='icon_update_time'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 15.769 16'>
                      <g data-name='Icon feather-clock' transform='translate(0.5 0.5)'>
                        <path d='M17.769,10.5A7.443,7.443,0,0,1,10.385,18,7.443,7.443,0,0,1,3,10.5,7.443,7.443,0,0,1,10.385,3,7.443,7.443,0,0,1,17.769,10.5Z' transform='translate(-3 -3)' />
                        <path d='M18,9v6.231l4.154,2.077' transform='translate(-11.365 -6.769)' />
                      </g>
                    </svg>
                  </span>
                  <span className='text_update_time'>{contentDateCast}</span>
                </div>
              )}
              <strong className='hmbif_title'>{title}</strong>
            </div>
          </a>
        </Link>
        {/* <ShareBox props /> */}
        <ShareBox data={props} />
      </div>

    </>
  );
}// Finish default function Box()
